import numeral from 'numeral';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import styleButton from '../../../../../shared/components/rbh-button/styles';
import styleImage from '../../../../../shared/components/rbh-image/styles';
import styles, { layout } from './styles';
import styleText from '../../../../../shared/components/rbh-text/styles';
import styleTextInput from '../../../../../shared/components/rbh-textinput/styles';
import { AuthHelper } from '../../../../../auth/auth-helper';
import { CAT_STATE_KEY, catStateSelector } from '../../../FoodCategory/redux/cat-reducer';
import { catCreators } from '../../../FoodCategory/redux/cat-action';
import { crop } from '../../../../../shared/helpers/crop';
import { FOOD_MENU_KEY, foodMenuStateSelector } from '../../redux/foodmenu-reducer';
import { FoodMenu } from '../../../../../shared/models/food-menu';
import {
  FOODMENU_INLINE_ERROR,
  FOODMENU_REQUEST_ID_LIST,
  MENU_PRICE_MAXLENGTH,
  MENU_PRICE_REGEX
} from '../../redux/foodmenu-constant';
import { foodMenuCreators } from '../../redux/foodmenu-action';
import { foodMenuSagas } from '../../redux/foodmenu-saga';
import { FoodMenuService } from '../../redux/foodmenu-service';
import {
  Form,
  Row,
  Select,
  Space,
  Tooltip
} from 'antd';
import { FormattedMessage } from 'react-intl';
import { GENERAL_STATE_KEY, generalStateSelector } from '../../../../../redux/general/general-reducer';
import { generalCreators } from '../../../../../redux/general/general-action';
import { MenuValidator } from '@ppvrbh/merchant-core';
import { httpCreators, Tags } from '@ppvrbh/merchant-frontend-core';
import { Images } from '../../../../../shared/theme';
import { MainHelper } from '../../../../main-helper';
import { mainStyles } from '../../../styles';
import { MERCHANT_TYPE } from '../../../../main-constant';
import { MODAL_TYPE } from '../../../../../redux/general/general-constant';
import {
  RBHBox,
  RBHButton,
  RBHImage,
  RBHSelect,
  RBHSwitch,
  RBHText,
  RBHTextInput,
  RBHTextInputArea
} from '../../../../../shared/components';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { UtilHelper } from '../../../../../shared/helpers/utility';
import './style.css';
import { MenuDiscountComponent } from './menu-discount/MenuDiscountComponent';
import moment from 'moment';
import { AdminCreateMenuV2, MenuDiscountDTO } from '../../interface';
import { DATE_FORMAT, DATE_TIME_FORMAT_NO_TZ } from '../../../../../shared/helpers/constant';
import { NextAvailableDiscountTimeGap, useMenuDiscount } from './menu-discount/useMenuDiscount';
import { reportCreators } from '../../../Report/redux/report-action';
import { MenuGroupForm } from '../../AddEditMenuScreen/components/MenuGroupForm';


export const FormAddEditMenu: React.FC<Props> = (p) => {
  const menu: FoodMenu | undefined = p.editData ? new FoodMenu(p.editData) : undefined;
  const defaultMenuCateogryId = p.defaultMenuCategoryId
  const dispatch = useDispatch();
  const menuStatusCode = MainHelper.getMasterDataByScheme('MenuStatus');
  const [menuStatus, setMenuStatus] = useState(menu ? menu.menuStatus === menuStatusCode[0] : true);
  const [form] = Form.useForm();
  const [menuId] = React.useState(menu ? menu.menuId : undefined);
  const [menuCategoryId] = React.useState(menu ? menu.menuCategory?.menuCategoryId : undefined);
  const [category] = React.useState(menu ? menu.menuCategory?.menuCategoryName : undefined);
  const [imageUpload, setImageUpload] = useState(menu ? menu.menuPhoto : null);
  const [lastFile, setLastFile] = useState(undefined);
  const inputRef = useRef<any>(null);
  const [formInvalid, setFormInvalid] = useState(!menu);
  const foodCategory = useSelector(catStateSelector(CAT_STATE_KEY.LIST)) as [];
  const isPOSActioned = useSelector(foodMenuStateSelector(FOOD_MENU_KEY.IS_POS_ACTIONED)) as boolean;
  const history = useHistory();
  const foodTags = useSelector(foodMenuStateSelector(FOOD_MENU_KEY.TAGS_LIST)) as Tags[];
  const isIndividual = AuthHelper.getMerchantTypeId() === MERCHANT_TYPE.INDIVIDUAL;
  const selectedTagId = form.getFieldsValue(['tagId'])?.tagId;
  const [selectedTag, setSelectedTag] = useState<Tags>();
  const [isDeletedTag, setIsDeletedTag] = useState<boolean>(false);
  const [modifierGroups, setModifierGroups] = useState(menu?.menuModifierGroups?.map(item => item.menuModifierGroupId) ?? [])
  const foodQcKeyword = useSelector(foodMenuStateSelector(FOOD_MENU_KEY.FOOD_QC_KEYWORD)) as string[];
  const initialMenuCategoryId = useMemo(() => {
    if (defaultMenuCateogryId) {
      return defaultMenuCateogryId
    }
    
    return menu?.menuCategory?.menuCategoryName
  }, [defaultMenuCateogryId, menu])

  useState(() => {
    dispatch(httpCreators.request({
      id: FOODMENU_REQUEST_ID_LIST.GET_FOOD_QC_KEYWORD,
      sagaHandler: foodMenuSagas.getFoodQcKeywordHandler,
      service: FoodMenuService.getFoodQcKeyword,
    }));
  });
  const [menuPriceValue, setMenuPriceValue] = useState<number>(menu?.menuOriginalPrice ?? 0);
  const appConfig = useSelector(generalStateSelector(GENERAL_STATE_KEY.REMOTE_CONFIG))

  // for menu discount feature
  const [deleteDiscountSwitch, setDeleteDiscountSwitch] = useState<boolean|undefined>();
  const [menuDiscountForm] = Form.useForm();
  const [menuDiscount, setMenuDiscount] = useState({
    data: menu?.menuDiscounts ?? [],
    deletedId: 0,
    openPanel: false,
  });
  const {getMaximumDiscountPercent, toMoment, isAfterDateBeforeStartDate } = useMenuDiscount()

  const onFailureCallback = () => {
    if (p.editData) {
      p.onSuccessCallback();
    } else {
      history.push('/main/foodcategory');
    }
  };

  const findTagInMasterData = useCallback((tagId: number) => {
    return foodTags?.find((value: Tags) => value.tagId === tagId)
  }, [foodTags]);

  useEffect(() => {
    setSelectedTag(findTagInMasterData(selectedTagId));
  }, [foodTags, selectedTagId]);

  useEffect(() => {
    if (!appConfig) {
      dispatch(reportCreators.callConfigAndShopList(() => {}, () => {}))
    }
  }, [])

  useEffect(() => {
    if (p.editData) {
      dispatch(catCreators.callFoodCategory(onFailureCallback, false));
      window.scrollTo({ top: 0, behavior: 'smooth' });
      form.validateFields();
    }
  }, [history]);

  useEffect(() => {
    if (menu?.menuDiscounts) {
      setMenuDiscount(prev => ({...prev, openPanel: Boolean(menu.menuDiscounts?.length)}))
    }
  }, [p])

  const trimFieldValue = (fieldName: string) => {
    const value = form.getFieldValue(fieldName);
    if (value) {
      form.setFieldsValue({
        [fieldName]: value.trim()
      });
      form.validateFields([fieldName]);
    }
  };

  const onBlurMenuPriceInput = () => {
    const value = form.getFieldValue('menuOriginalPrice');
    form.setFieldsValue({
      menuOriginalPrice: UtilHelper.currencyFormat(value)
    });

    if (menuPriceValue !== Number(UtilHelper.removeComma(value)) && menuDiscount.data?.length) {
      dispatch(
        generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL,
          {
            visible: true,
            type: MODAL_TYPE.DELETE_DISCOUNT,
            modalTitle: 'main.foodmenu.deletemenu.originalPriceChange.title',
            modalContent: 'main.foodmenu.deletemenu.originalPriceChange.content',
            onOk: () => {
              setDeleteDiscountSwitch(prev => !Boolean(prev))
              setMenuPriceValue(Number(UtilHelper.removeComma(value)) || 0);
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: false,
              }))
            },
            onCancel: () =>{
              form.setFieldsValue({
                menuOriginalPrice: UtilHelper.currencyFormat(menuPriceValue)
              });
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                  visible: false,
              }))
            } 
          }
      ))
    } else {
      setMenuPriceValue(Number(UtilHelper.removeComma(value)) || 0);
    }
  };

  const onFocusMenuPriceInput = () => {
    const value = form.getFieldValue('menuOriginalPrice');
    form.setFieldsValue({
      menuOriginalPrice: UtilHelper.removeComma(value)
    });
  };

  const handleChangePhoto = (file: any) => {

    if (file.target.files[0] && (file.target.files[0].type === 'image/png' || file.target.files[0].type === 'image/jpeg')) {
      setLastFile(file.target.files);
      crop(URL.createObjectURL(file.target.files[0]), 1).then((canvas: any) => {
        setImageUpload(canvas);
      });
    } else {
      if (lastFile) {
        inputRef.current.files = lastFile;
      } else {
        inputRef.current.value = '';
      }
    }
  };

  const { Option } = Select;
  const getSelectOption = () => {
    if (foodCategory && foodCategory.length > 0) {
      return foodCategory.map((result: any, index: number) => {
        return (
          result.menuCategoryTypeId === 2 ?
            <Option
              key={index}
              id={`categoryOption-${index}`}
              data-testid={`categoryOption-${index}`}
              value={result.menuCategoryId}
              style={styles.option_promotion}
              title={result.menuCategoryName}
            >
              <img src={Images.promotion} style={styleImage.iconS} />
              {result.menuCategoryName}
            </Option>
            :
            <Option
              key={index}
              id={`categoryOption-${index}`}
              data-testid={`categoryOption-${index}`}
              value={result.menuCategoryId}
              style={styleText.textRegular14}
              title={result.menuCategoryName}
            >
              {result.menuCategoryName}
            </Option>
        );
      });
    }
    return null;
  };

  const getTagsSelectOption = () => {
    if (foodTags && foodTags.length > 0) {
      return foodTags
        .filter((result: Tags) => !result.isDeleted)
        .map((result: Tags, index: number) => {
          return (
            <Option
              key={index}
              id={`tagsOption-${index}`}
              data-testid={`tagsOption-${index}`}
              value={result.tagId}
              style={styleText.textRegular14}
              title={result.tagTh}
            >
              {result.tagTh}
            </Option>
          );
        });
    }
    return null;
  };

  const validateMenuSku = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch(foodMenuCreators.setFoodMenuState(FOOD_MENU_KEY.IS_POS_ACTIONED, true));
    form.validateFields(['menuSKUId']);
  };

  const setFieldError = (fieldName: string, errorShow: string[]) => {
    form.setFields([{
      name: fieldName,
      errors: errorShow
    }]);
    const fieldError = form.getFieldsError();
    const errorField = fieldError.find((e: any) => e.errors[0] === FOODMENU_INLINE_ERROR.MENU_NAME_DUP);
    form.scrollToField(`${errorField?.name}`, { behavior: 'smooth' });
    setFormInvalid(true);
  };

  const clearFieldTagIsDeleted = () => {
    setIsDeletedTag(true);
    form.resetFields(['tagId']);
    setFieldError('tagId', [FOODMENU_INLINE_ERROR.MENU_TAGS_TH_INVALID]);
  };

  const submitMenuDiscount = (): {error: boolean; menuItemDiscount?: MenuDiscountDTO} => {
    const fields =  menuDiscountForm.getFieldsValue()
    let error = false;
    let timeError = false;
    if (!menuDiscount.openPanel) {
      return {error: false, menuItemDiscount: menuDiscount.deletedId ? {deleteDiscountIds: [menuDiscount.deletedId]}: undefined}
    }
    if (!fields.discountedAmount) {
      error = true;
      menuDiscountForm.setFields([{
        name: 'discountedAmount',
        errors: [FOODMENU_INLINE_ERROR.DISCOUNT_PRICE_UNDEFINED]
      }])
    } else if (Number(UtilHelper.removeComma(fields.discountedAmount)) <= 0) {
      error = true;
      const maxPercent = getMaximumDiscountPercent()
      menuDiscountForm.setFields([{
        name: 'discountedAmount',
        errors: [FOODMENU_INLINE_ERROR.DISCOUNT_PRICE_INVALID.replace('%s', String(maxPercent))]
      }])
    }
    if (!fields.startPromotionDate?.isValid()) {
      timeError = true;
      menuDiscountForm.setFields([{
        name: 'startPromotionDate',
        errors: [FOODMENU_INLINE_ERROR.DISCOUNT_START_DATE_UNDEFINED]
      }])
    }
    if (!fields.startPromotionTime) {
      timeError = true;
      menuDiscountForm.setFields([{
        name: 'startPromotionTime',
        errors: [FOODMENU_INLINE_ERROR.DISCOUNT_START_TIME_UNDEFINED]
      }])
    }

    if (fields.isEnableEndDate && !fields.endPromotionDate?.isValid()) {
      timeError = true;
      menuDiscountForm.setFields([{
        name: 'endPromotionDate',
        errors: [FOODMENU_INLINE_ERROR.DISCOUNT_END_DATE_UNDEFINED]
      }])
    }
    if (fields.isEnableEndDate && !fields.endPromotionTime) {
      timeError = true;
      menuDiscountForm.setFields([{
        name: 'endPromotionTime',
        errors: [FOODMENU_INLINE_ERROR.DISCOUNT_END_TIME_UNDEFINED]
      }])
    }

    
    const initialStartDate = menuDiscount.data?.[0]?.startDate ? moment(menuDiscount.data[0].startDate) : undefined
    const now = moment()
    if (!timeError && (!initialStartDate || isAfterDateBeforeStartDate(initialStartDate, now, NextAvailableDiscountTimeGap))) {
      const startPromotionDateTime = toMoment(fields.startPromotionDate, fields.startPromotionTime);
      const endPromotionDateTime = fields.isEnableEndDate ? toMoment(fields.endPromotionDate, fields.endPromotionTime) : undefined
      
      if(endPromotionDateTime && isAfterDateBeforeStartDate(startPromotionDateTime, endPromotionDateTime)) {
        timeError = true;
        menuDiscountForm.setFields([
          {
            name: 'startPromotionDate',
            errors: [FOODMENU_INLINE_ERROR.DISCOUNT_START_DATETIME_INVALID]
          },
          {
            name: 'startPromotionTime',
            errors: ['']
          },
        ])
      }
    }

    const startDate = menuDiscountForm.getFieldValue('startPromotionDate');
    const startTime = menuDiscountForm.getFieldValue('startPromotionTime');
    const startPromotionDateTime = moment(startDate.format(DATE_FORMAT) + startTime, 'YYYY-MM-DDHH:mm');
    let endPromotionDateTime = undefined;
    if (!timeError && fields.isEnableEndDate) {
      const endDate = menuDiscountForm.getFieldValue('endPromotionDate');
      const endTime = menuDiscountForm.getFieldValue('endPromotionTime')
      endPromotionDateTime = moment(endDate.format(DATE_FORMAT) + endTime, 'YYYY-MM-DDHH:mm')
      if (isAfterDateBeforeStartDate(startPromotionDateTime, endPromotionDateTime, NextAvailableDiscountTimeGap)) {
        timeError = true;
        menuDiscountForm.setFields([
          {
            name: 'endPromotionDate',
            errors: [FOODMENU_INLINE_ERROR.DISCOUNT_DURATION_INVALID]
          },
          {
            name: 'endPromotionTime',
            errors: ['']
          }
        ])
      }
    }
    if (error || timeError) {
      return {error: true, menuItemDiscount: undefined};
    }

    const isEdit = menuDiscount.data.length;
    const payload = {
          priceDiscount: Number(UtilHelper.removeComma(fields.discountedAmount)),
          startDate: startPromotionDateTime!.format(DATE_TIME_FORMAT_NO_TZ),
          endDate: endPromotionDateTime ? endPromotionDateTime.format(DATE_TIME_FORMAT_NO_TZ) : null
        }
    return {
      error: false,
      menuItemDiscount: {
        createDiscounts: isEdit ? undefined : [payload],
        updateDiscounts: isEdit ? [{
          ...payload,
          id: menuDiscount.data[0].menuDiscountId
        }]: undefined,
        deleteDiscountIds: menuDiscount.deletedId ? [menuDiscount.deletedId] : undefined
      }
    }
  }

  const onFinish = async (values: any) => {
    const {error, menuItemDiscount} = submitMenuDiscount()
    if (error) return;

    const formData = form.getFieldsValue();
    const data = {
      menuId: p.editData ? Number(menuId) : null,
      menuCategoryId: p.editData ? values.menuCategoryId === category ? menuCategoryId : Number(formData.menuCategoryId) : values.menuCategoryId,
      menuName: values.menuName,
      menuDescription: values.menuDescription,
      menuNameEN: values.menuNameEN,
      menuDescriptionEN: values.menuDescriptionEN,
      menuOriginalPrice: numeral(values.menuOriginalPrice).value(),
      menuPhoto: imageUpload,
      menuStatus: menuStatus ? menuStatusCode[0] : menuStatusCode[1],
      menuSKUId: values.menuSKUId,
      tagId: values.tagId,
      menuDiscounts: menuItemDiscount,
      menuModifierGroupIds: modifierGroups,
    }
    if (p.editData) {
      if (imageUpload === p.editData.menuPhoto) {
        delete data.menuPhoto;
      }
      dispatch(httpCreators.request({
        id: FOODMENU_REQUEST_ID_LIST.PATCH_FOOD_MENU,
        sagaHandler: foodMenuSagas.postPatchMenuHandler as any,
        callbackParams: { onSuccessCallback: p.onSuccessCallback, validateMenuSku, setFieldError, clearFieldTagIsDeleted },
        service: FoodMenuService.patchFoodMenus,
        serviceParams: data,
      }));
    } else {
      const createdRequestBody: AdminCreateMenuV2 = {
        menuCategoryId: p.editData ? values.menuCategoryId === category ? menuCategoryId : Number(formData.menuCategoryId) : values.menuCategoryId,
        menuName: values.menuName,
        menuDescription: values.menuDescription,
        menuNameEN: values.menuNameEN,
        menuDescriptionEN: values.menuDescriptionEN,
        menuOriginalPrice: numeral(values.menuOriginalPrice).value() ?? 0,
        menuPhoto: imageUpload ?? undefined,
        menuStatus: menuStatus ? menuStatusCode[0] : menuStatusCode[1],
        menuSKUId: values.menuSKUId,
        tagId: values.tagId,
        menuDiscounts: menuItemDiscount,
        menuModifierGroupIds: modifierGroups,
      }
      dispatch(httpCreators.request({
        id: FOODMENU_REQUEST_ID_LIST.POST_FOOD_MENU,
        sagaHandler: foodMenuSagas.postPatchMenuHandler as any,
        callbackParams: { onSuccessCallback: p.onSuccessCallback, validateMenuSku, setFieldError, clearFieldTagIsDeleted },
        service: FoodMenuService.postFoodMenus,
        serviceParams: createdRequestBody,
      }));
    }
  };

  const checkFormInvalid = () => {
    let invalid = false;
    const values = form.getFieldsValue();
    for (const key in values) {
      if (!(key === 'menuDescription' || key === 'menuNameEN' || key === 'menuDescriptionEN' || key === 'photoURL' ||
        (key === 'menuSKUId' && !isPOSActioned))) {
        if (values[key] === undefined || values[key] === '') {
          invalid = true;
          break;
        }
      }
    }

    if (!invalid) {
      const errors = form.getFieldsError();
      for (const field of errors) {
        if (field.errors.length > 0) {
          invalid = true;
          break;
        }
      }
    }
    setFormInvalid(invalid);
  };

  const textTipsNameMenu = () => {
    return (
      <>
        <pre id='tooltipsContent' style={mainStyles.box_name_Tooltip}>
          <div id='menuNameTooltip'><FormattedMessage id={'main.foodmenu.addmenu.menu.tips.title'} /></div>
        </pre>
      </>
    );
  };

  const textTipsPricesMenu = () => {
    return (
      <a id='prices-tooltips' style={mainStyles.box_prices_Tooltip}>
        <FormattedMessage id={'main.foodmenu.addmenu.prices.tips'} />
      </a>
    );
  };

  const handleDiscountPanelChange = (openPanel: boolean) => {
    setMenuDiscount(prev => ({...prev, openPanel}))
  }

  const textOptional = (id: string) => {
    return (
      <RBHBox style={{ display: 'flex' }}>
        <RBHText data-testid={id} style={styleText.formText} text={id} />&nbsp;
        <RBHText data-testid={'ifOptional'} style={styleText.textRegular14Gray} text={'main.form.text.optional'} />
      </RBHBox>
    );
  };

  const dispatchModal = (path: any) => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => history.push(path),
      type: MODAL_TYPE.CONFIRM_EDIT
    }));
  };

  const handleDeleteMenuDiscount = (id: number) => {
    setMenuDiscount({deletedId: id, data: [], openPanel: false})
  }

  return (
    <Form size='large' style={styleText.formText} {...layout} form={form} onFinish={onFinish} onFieldsChange={checkFormInvalid}>
      {
        isIndividual && <Form.Item colon={false} required={true}
          label={<FormattedMessage id={'main.foodmenu.addmenu.tags.title'} />}
          extra={
            !!selectedTag?.remark && (
              <RBHText
                data-testid={'tagPickerRemark'}
                id={'tagPickerRemark'}
                style={styles.tagPickerRemark}
              >
                {selectedTag?.remark}
              </RBHText>
            )
          }>
          <Form.Item noStyle name='tagId'
            rules={[
              {
                required: true,
                message: <FormattedMessage id={'main.form.required2'} />
              }, () => ({
                validator(_, formValue) {
                  const currentTag = findTagInMasterData(formValue);
                  if (currentTag?.isDeleted) {
                    setIsDeletedTag(true);
                    return Promise.reject(<FormattedMessage id={'main.foodmenu.addmenu.form.tag.isDeleted'} />);
                  }
                  return Promise.resolve();
                }
              })
            ]}
            initialValue={menu ? menu.tagId : undefined}>
            <RBHSelect
              optionFilterProp='children'
              showSearch
              id='foodTagPicker'
              data-testid='foodTagPicker'
              placeholder={isDeletedTag ? 'main.foodmenu.addmenu.form.tag.isDeleted.placeholder' : 'main.foodmenu.addmenu.tags.placeholder'}
              defaultValue={isDeletedTag ? undefined : menu?.tag?.tagTh}
              onChange={(tagId: number) => {
                setSelectedTag(findTagInMasterData(tagId));
                setIsDeletedTag(false);
                form.validateFields(['tagId'])
                form.setFieldsValue({
                  'tagId': tagId
                });
              }}>
              {getTagsSelectOption()}
            </RBHSelect>
            {/* fix form prefill with tagId when tag isDeleted = true */}
            <RBHBox />
          </Form.Item>
        </Form.Item>
      }

      <Form.Item colon={false} required={true} label={<FormattedMessage id={'main.foodmenu.addmenu.category.title'} />}>
        <Form.Item noStyle name='menuCategoryId'
          rules={[{ required: true }]}
          initialValue={initialMenuCategoryId}>
          <RBHSelect optionFilterProp='children' showSearch placeholder='main.foodmenu.addmenu.category.placeholder'>
            {getSelectOption()}
          </RBHSelect>
        </Form.Item>
        <span id='add-menu-link' style={styles.addBranchText} onClick={() => dispatchModal('/main/addfoodcategory')}>
          <span>+ </span>
          <span style={styles.addBranchTextInner}><FormattedMessage id={'main.foodmenu.addmenu.category.addcategort'} /></span>
        </span>
      </Form.Item>

      <Tooltip id='tooltip-menu-name' placement='bottom' title={textTipsNameMenu} trigger={'focus'}>
        <Form.Item colon={false} validateTrigger={['onChange', 'onBlur']} name='menuName'
          label={<FormattedMessage id={'main.foodmenu.addmenu.menu.title'} />}
          rules={[
            { required: true, message: <FormattedMessage id='main.form.required' /> },
            { pattern: MenuValidator.menuName.regexPattern, message: <FormattedMessage id='main.form.name.menu.valid' /> },
            { max: MenuValidator.menuName.maxLength, message: <FormattedMessage id='main.form.maxlength' /> },
            {
              validator(_, value) {
                let containsQcKeywordSize = foodQcKeyword
                  .map(each => { return each.toLowerCase() })
                  .filter(each => { return (value ? value.toLowerCase() : '').includes(each); })
                  .length
                if (containsQcKeywordSize > 0) {
                  return Promise.reject('main.form.containsqckeyword');
                } else {
                  return Promise.resolve();
                }
              }, message: <FormattedMessage id='main.form.containsqckeyword' />
            }]}
          initialValue={menu ? menu.menuName : undefined}>
          <RBHTextInput
            id='menuName'
            onBlur={() => trimFieldValue('menuName')}
            maxLength={MenuValidator.menuName.maxLength}
            placeholder={'main.foodmenu.addmenu.menu.placeholder'}
            autoComplete='off'
          />
        </Form.Item>
      </Tooltip>

      <Form.Item colon={false} name='menuDescription' label={textOptional('main.foodmenu.addmenu.description.title')}
        initialValue={menu ? menu.menuDescription : ''} validateTrigger={['onChange', 'onBlur']}
        rules={[
          { pattern: MenuValidator.menuDescription.regexPattern, message: <FormattedMessage id='main.form.name.menu.valid' /> }]}>
        <RBHTextInputArea id='menuDescription' placeholder={'main.foodmenu.addmenu.description.placeholder'}
          onBlur={() => trimFieldValue('menuDescription')} maxLength={MenuValidator.menuDescription.maxLength} />
      </Form.Item>

      <Form.Item colon={false} name='menuNameEN' label={textOptional('main.foodmenu.addmenu.menu.titleEN')}
        initialValue={menu ? menu.menuNameEN : ''} validateTrigger={['onChange', 'onBlur']}
        rules={[
          { pattern: MenuValidator.menuNameEN.regexPattern, message: <FormattedMessage id='main.form.name.menu.validEN' /> },
          {
            validator(_, value) {
              let containsQcKeywordSize = foodQcKeyword
                .map(each => { return each.toLowerCase() })
                .filter(each => { return (value ? value.toLowerCase() : '').includes(each); })
                .length
              let regExp = MenuValidator
                .menuNameEN
                .regexPattern as RegExp;
              if (containsQcKeywordSize > 0 && regExp.test(value)) {
                return Promise.reject('main.form.containsqckeyword');
              } else {
                return Promise.resolve();
              }
            }, message: <FormattedMessage id='main.form.containsqckeyword' />
          }]}>
        <RBHTextInput id='menuNameEN' placeholder={'main.foodmenu.addmenu.menu.placeholderEN'}
          onBlur={() => trimFieldValue('menuNameEN')} maxLength={MenuValidator.menuNameEN.maxLength} autoComplete='off' />
      </Form.Item>

      <Form.Item colon={false} name='menuDescriptionEN' label={textOptional('main.foodmenu.addmenu.description.titleEN')}
        initialValue={menu ? menu.menuDescriptionEN : ''} validateTrigger={['onChange', 'onBlur']}
        rules={[
          { pattern: MenuValidator.menuDescriptionEN.regexPattern, message: <FormattedMessage id='main.form.name.menu.validEN' /> }]}
        extra={<RBHBox>
          <RBHText data-testid={'menuEN-remark'} id={'menuEN-remark'} style={styles.remark}
            text={'main.foodmenu.addmenu.description.remarkEN'} />
        </RBHBox>}>
        <RBHTextInputArea id='menuDescriptionEN' placeholder={'main.foodmenu.addmenu.description.placeholderEN'}
          onBlur={() => trimFieldValue('menuDescriptionEN')} maxLength={MenuValidator.menuDescriptionEN.maxLength} />
      </Form.Item>

      {isPOSActioned ?
        <Form.Item colon={false} required={isPOSActioned} name={'menuSKUId'} initialValue={menu ? menu.menuSKUId : ''}
          label={
            <RBHBox>
              <RBHText id={'foodmenu-menuSKUId-required-label'} data-testid={'main.foodmenu.addmenu.menuSKUId.title'}
                style={styleText.formText} text={'main.foodmenu.addmenu.menuSKUId.title'} />
            </RBHBox>
          }
          rules={[
            { required: true, message: <FormattedMessage id={'main.form.required'} /> },
            { pattern: MenuValidator.menuSKUId.regexPattern, message: <FormattedMessage id={'main.form.text.valid'} /> }]}
          validateTrigger={['onChange', 'onBlur']}>
          <RBHTextInput id={'menuSKUId'} placeholder={'main.foodmenu.addmenu.menuSKUId.placeholder'} style={{ fontSize: 13 }}
            onBlur={() => trimFieldValue('menuSKUId')} maxLength={MenuValidator.menuSKUId.maxLength} autoComplete={'off'} />
        </Form.Item>
        :
        <Form.Item colon={false} name={'menuSKUId'} label={textOptional('main.foodmenu.addmenu.menuSKUId.title')}
          initialValue={menu ? menu.menuSKUId : ''}
          rules={[
            { pattern: MenuValidator.menuSKUId.regexPattern, message: <FormattedMessage id={'main.form.text.valid'} /> }]}>
          <RBHTextInput id={'menuSKUId'} placeholder={'main.foodmenu.addmenu.menuSKUId.placeholder'} style={{ fontSize: 13 }}
            onBlur={() => trimFieldValue('menuSKUId')} maxLength={MenuValidator.menuSKUId.maxLength} autoComplete={'off'} />
        </Form.Item>
      }

      <Tooltip id={'tooltip-menu-price'} placement={'bottom'} title={textTipsPricesMenu} trigger={'focus'}>
        <Form.Item colon={false} validateTrigger={['onChange', 'onBlur']} name={'menuOriginalPrice'} validateFirst
          label={<FormattedMessage id={'main.foodmenu.addmenu.prices.title'} />}
          rules={[
            { required: true, message: <FormattedMessage id={'main.form.required'} /> },
            {
              pattern: MENU_PRICE_REGEX,
              message: <FormattedMessage id={'main.foodmenu.addmenu.prices.validate'} />
            }
          ]}
          initialValue={menu ? numeral(menu.menuOriginalPrice).format('0,0') : undefined}>
          <RBHTextInput id={'menuOriginalPrice'} style={styleTextInput.inputWidth142} placeholder={'main.foodmenu.addmenu.prices.placeholder'}
            maxLength={MENU_PRICE_MAXLENGTH}
            autoComplete={'off'}
            onFocus={onFocusMenuPriceInput}
            onBlur={onBlurMenuPriceInput}
          />
        </Form.Item>
      </Tooltip>

      <Form.Item name='photoURL' colon={false} label={textOptional('main.foodmenu.addmenu.picture.title')}
        initialValue={menu ? menu.menuPhoto : undefined}>
        <RBHBox>
          <Row justify='start' align='middle'>
            <Space size={'middle'}>
              <RBHBox>
                <RBHImage id='image_upload' name='image_upload' style={mainStyles.imageBox} src={imageUpload || Images.menudefault2} />
              </RBHBox>
              <RBHBox style={mainStyles.uploadBox}>
                <label>
                  <input ref={inputRef} id='file-upload' accept='image/png, image/jpeg, image/jpg' type='file'
                    onChange={(e: any) => handleChangePhoto(e)} />
                  <RBHBox style={mainStyles.upload}>
                    <RBHText id='file-upload-text' style={styleText.text16LightPurple} text={'main.foodmenu.addmenu.picture.button.title'} />
                  </RBHBox>
                </label>
              </RBHBox>
            </Space>
          </Row>
          <RBHBox style={mainStyles.paddingWarning}>
            <RBHText id='text-photo-warning' style={styleText.textRegular14Gray} text={'main.foodmenu.addmenu.picture.warning'} />
          </RBHBox>
        </RBHBox>
      </Form.Item>

      <Form.Item colon={false} label={<FormattedMessage id='main.foodmenu.addmenu.status.title' />}>
        <RBHBox style={mainStyles.displayinline}>
          <RBHSwitch id='status' size={'small'}
            defaultChecked={menuStatus} onChange={() => setMenuStatus(!menuStatus)}
          />
        </RBHBox>
        <RBHBox style={mainStyles.displayinline_left_13px}>
          {menuStatus ?
            <RBHText id='menu_status_text' style={styleText.formText} text={'main.foodmenu.addmenu.status.text.true'} /> :
            <RBHText id='menu_status_text' style={styleText.textRegular14Gray} text={'main.foodmenu.addmenu.status.text.false'} />}
        </RBHBox>
      </Form.Item>
      
      <Form.Item style={{flexFlow: 'row'}} colon={false} label={<FormattedMessage id='main.foodmenu.addmenu.menudiscount.title' />}>
        <MenuDiscountComponent
          shouldEnable={p.shouldEnableStrikethrough}
          open={menuDiscount.openPanel}
          menuDiscounts={menuDiscount.data}
          deleteDiscountSwitch={deleteDiscountSwitch}
          onOpenChange={handleDiscountPanelChange}
          form={menuDiscountForm}
          normalPrice={menuPriceValue}
          handleDeletedMenu={handleDeleteMenuDiscount}
        />
      </Form.Item>
      <Form.Item style={{flexFlow: 'row'}} colon={false} label={<FormattedMessage id='main.foodmenu.addmenu.modifiergroups.title' />}>
        <RBHBox >
          <MenuGroupForm menu={menu} onChange={setModifierGroups}/>
        </RBHBox>
      </Form.Item>

      <RBHText style={styles.warning}
        text={'main.foodmenu.addmenu.description.warning'} />
      <Space size={'middle'}>
        <RBHBox>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }} />
        </RBHBox>
      </Space>

      <Row justify='center' align='middle' >
        <Space size={'middle'}>
          <RBHButton style={styleButton.buttonModalCancelGradient} id='add_menu_button_cancel' type='primary' htmlType='button'
            onClick={() => p.onCancel('foodcategory')}>
            <FormattedMessage id='main.foodmenu.addmenu.button.title.cancel' />
          </RBHButton>
          {!menu ?
            <RBHButton style={styleButton.buttonModalConfirmGradient} id='add_menu_button_submit' type='primary' htmlType='submit'
              disabled={formInvalid}>
              <FormattedMessage id='main.foodmenu.addmenu.button.title.submit' />
            </RBHButton> : null}
          {menu ?
            <RBHButton disabled={formInvalid} id='menu_button_save' style={styleButton.buttonModalConfirmGradient} type='primary'
              htmlType='submit' text='main.branchform.save' /> : null}
        </Space>
      </Row>
    </Form>
  );
};

type Props = {
  onSuccessCallback: any,
  shouldEnableStrikethrough: boolean;
  defaultMenuCategoryId?: number;
  onCancel?: any,
  editData?: any
};
